import React, { useEffect, useRef, useState } from "react";
import classes from "../Components/WatchlistModal.module.css";
import { useAppDispatch, useAppSelector } from "../Store/hooks";
import { useAnimationControls, motion } from "framer-motion";
import BackgroundWatchlist from "./BackgroundWatchlist";
import { useNavigate } from "react-router-dom";
import { toggleUserRatingsModal } from "../Slices/userRatingsModalSlice";
import {
  useDeleteUserReviewMutation,
  useEditUserReviewMutation,
  useGetUserReviewsMutation,
} from "../Slices/httpSlice";
import { toast } from "react-toastify";
import Spinner from "./Loaders/Spinner";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";
import { logoutUser } from "../Slices/userSlice";
import { setAuthModal } from "../Slices/authModalSlice";

const UserRatingsModal = () => {
  const lastItemRef = useRef<HTMLDivElement | null>(null);

  const { userRatingsModal } = useAppSelector(
    (state) => state.userRatingsModalSlice
  );

  const { user } = useAppSelector((state) => state.userSlice);

  const [getUserReviews, { isLoading: isLoading }] =
    useGetUserReviewsMutation();

  const [offset, setOffset] = useState<number>(0);
  const [fetchData, setFetchData] = useState<boolean>(false);
  const [userRatings, setUserRatings] = useState([]);

  const [editReview, setEditReview] = useState<any>({
    state: false,
    editReviewId: null,
    reviewStars: 0,
    reviewHeadline: "",
    reviewDescription: "",
  });

  const [deleteReview, setDeleteReview] = useState<any>({
    state: false,
    reviewId: null,
    mediaName: "",
  });

  useEffect(() => {
    if (userRatingsModal) {
      controls.start("visible");
      setFetchData(false);
      setOffset(0);
      setUserRatings([]);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [userRatingsModal]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (userRatingsModal && entries[0].isIntersecting && !fetchData) {
          fetchUserRatings();
          setFetchData(true);
        }
      },
      { threshold: 1.0 }
    );

    if (lastItemRef.current) {
      observer.observe(lastItemRef.current);
    }

    return () => {
      if (lastItemRef.current) {
        observer.unobserve(lastItemRef.current);
      }
    };
  }, [userRatingsModal, fetchData, isLoading]);

  const fetchUserRatings = async () => {
    const response: any = await getUserReviews({
      body: {
        user_id: user?.id,
        offset: offset,
      },
      token: user?.token,
    });
    console.log(response, "r");
    if (response?.error) {
      console.log(response.error, "error");
      if (response?.error?.status === 403) {
        toast.error("သင့်စက်ရှင် သက်တမ်းကုန်သွားပါပြီ။ ထပ်မံဝင်ရောက်ပါ။");
        dispatch(logoutUser(null));
        closeUserRatingsModal();
        dispatch(setAuthModal({ authModal: true, authModalType: "signin" }));
        return;
      }
      toast.error(
        response?.error?.data?.message ||
          response?.error?.data?.error ||
          response?.error?.data ||
          response?.error?.message ||
          "Something Went Wrong!"
      );
    } else {
      if (response?.data?.result.length === 0) {
        return;
      }
      setFetchData(false);
      setOffset(response?.data?.result.length + userRatings.length);
      setUserRatings((prevValue) =>
        prevValue.length > 0
          ? [...prevValue, ...response?.data?.result]
          : response?.data?.result
      );
    }
  };

  console.log({ userRatings, offset, fetchData }, "execution");

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const controls = useAnimationControls();

  const variants = {
    hidden: {
      y: window.innerHeight,
      display: "none",
    },
    visible: {
      y: 0,
      display: "block",
    },
  };

  const closeUserRatingsModal = () => {
    controls.start("hidden");
    setFetchData(false);
    setOffset(0);
    setUserRatings([]);
    dispatch(toggleUserRatingsModal());
  };

  const [editReviewApi, { isLoading: editLoading }] =
    useEditUserReviewMutation();

  const [deleteReviewApi, { isLoading: deleteLoading }] =
    useDeleteUserReviewMutation();

  const submitHandler = async () => {
    if (
      editReview?.reviewStars === 0 ||
      editReview?.reviewHeadline.trim().length === 0 ||
      editReview?.reviewDescription.trim().length === 0
    ) {
      toast.error(
        "သုံးသပ်ချက်အတွက် လိုအပ်သောအသေးစိတ်အချက်များအားလုံးကို ဖြည့်စွက်ထားကြောင်း သေချာပါစေ။"
      );
      return;
    }
    const response: any = await editReviewApi({
      body: {
        review_id: editReview?.editReviewId,
        stars: editReview?.reviewStars,
        headline: editReview?.reviewHeadline,
        review: editReview?.reviewDescription,
      },
      token: user?.token,
    });
    console.log(response, "response....");

    if (response?.error) {
      console.log(response.error, "error");
      if (response?.error?.status === 403) {
        toast.error("သင့်စက်ရှင် သက်တမ်းကုန်သွားပါပြီ။ ထပ်မံဝင်ရောက်ပါ။");
        dispatch(logoutUser(null));

      } else {
        toast.error(
          response?.error?.data?.error?.error ||
          response?.error?.data?.error ||
          response?.error?.data?.message ||
          response?.error?.message ||
          "Something Went Wrong!" 
        );
      }
    } else {
      setEditReview({
        state: false,
        editReviewId: null,
        reviewStars: 0,
        reviewHeadline: "",
        reviewDescription: "",
      });
      setFetchData(false);
      setOffset(0);
      setUserRatings([]);
      fetchUserRatings();
      // closeReviewModal();
      toast.success("သုံးသပ်ချက် တည်းဖြတ်ပြီးပါပြီ။");
    }
  };

  const deleteReviewHandler = async () => {
    const response: any = await deleteReviewApi({
      body: {
        review_id: deleteReview?.reviewId,
      },
      token: user?.token,
    });
    console.log(response, "response....");

    if (response?.error) {
      console.log(response.error, "error");
      if (response?.error?.status === 403) {
        toast.error("ကျေးဇူးပြု၍ ထပ်မံဝင်ရောက်ပါ၊ တိုကင်သက်တမ်းကုန်ပါပြီ။");
      } else {
        toast.error(
          response?.error?.data?.error?.error ||
          response?.error?.data?.error ||
          response?.error?.data?.message ||
          response?.error?.message || 
          "Something Went Wrong!" 
        );
      }
    } else {
      setDeleteReview({
        state: false,
        deleteReviewId: null,
        mediaName: "",
      });

      setFetchData(false);
      setOffset(0);
      setUserRatings([]);
      fetchUserRatings();
      // closeReviewModal();
      toast.success("သုံးသပ်ချက်ကို အောင်မြင်စွာ ဖျက်လိုက်ပါပြီ။");
    }
  };

  return (
    <motion.div
      className={classes.modal}
      variants={variants}
      initial="hidden"
      animate={controls}
      transition={{
        duration: 0.5,
        type: "spring",
        damping: 10,
        stiffness: 100,
      }}
    >
      <BackgroundWatchlist>
        <div className={classes.navbar}>
          <button
            className={classes.close_btn}
            type="button"
            onClick={closeUserRatingsModal}
          >
            <i className={`pi pi-times ${classes.close_icon}`} />
          </button>
        </div>
        <div className={classes.info_container}>
          <p className={classes.info}>သင့်အဆင့်သတ်မှတ်ချက်များ</p>
          <p className={classes.info_brief}>
          သင့်အဆင့်သတ်မှတ်ချက်များသည် သင်အဆင့်သတ်မှတ်ထားသော ခေါင်းစဉ်များကို ခြေရာခံရန်နေရာဖြစ်သည်။
          </p>
        </div>
      </BackgroundWatchlist>

      <div className={classes.watchlist_content}>
        <div className={classes.watchlist_header}>
          <p className={classes.watchlist_name}>သင့်အဆင့်သတ်မှတ်ချက်များ</p>
        </div>

        <div className={classes.user_rating_wrapper}>
          {userRatings.length === 0 ? (
            <p className={classes.message}>
             သင်သည် မည်သည့်အဆင့်သတ်မှတ်ချက်ကိုမျှ မပေးသေးပါ။
            </p>
          ) : (
            <React.Fragment>
              {userRatings?.map((dataItem: any, idx) => {
                return (
                  <div className={classes.user_rating_container} key={idx}>
                    <button className={classes.main_card_2}>
                      <div className={classes.main_card_image}>
                        <img
                          src={`${process.env.REACT_APP_MEDIA_PATH_PREFIX?.replace(
                            "<replace_media_id>",
                            JSON.parse(dataItem?.media_poster)
                          )}`}
                          alt="movie"
                          className={classes.main_card_img}
                        />
                      </div>
                      <div className={classes.main_card_content}>
                        <p className={classes.main_card_title}>
                          {dataItem?.media_name}
                        </p>
                      </div>
                    </button>

                    <div className={classes.review_card}>
                      {editReview?.state === true &&
                      editReview?.editReviewId === dataItem?.id ? (
                        <form className={classes.form_container}>
                          <div className={classes.review_star_container}>
                            <div className={classes.review_stars}>
                              {Array.from({ length: 10 }).map(
                                (_, idx: number) => {
                                  return (
                                    <>
                                      <motion.i
                                        whileHover={{ color: "yellow" }}
                                        onClick={() =>
                                          setEditReview({
                                            ...editReview,
                                            reviewStars: idx + 1,
                                          })
                                        }
                                        className={`pi ${
                                          editReview?.reviewStars <= idx
                                            ? `pi-star`
                                            : `pi-star-fill`
                                        } ${
                                          editReview?.reviewStars <= idx
                                            ? classes.star_icon
                                            : classes.star_filled_icon
                                        }`}
                                      ></motion.i>
                                    </>
                                  );
                                }
                              )}
                            </div>
                            {editReview?.reviewStars > 0 && (
                              <p className={classes.review_given}>
                               သင်ဤအရာကို အဆင့်သတ်မှတ်ခဲ့သည်။ {editReview?.reviewStars}/10
                              </p>
                            )}
                          </div>

                          <div className={classes.edit_review_inputs_wrapper}>
                            <InputText
                              type="text"
                              className={`p-inputtext-lg ${classes.input_edit_review}`}
                              placeholder="သင့်သုံးသပ်ချက်အတွက် ခေါင်းစဉ်တစ်ခုကို ဤနေရာတွင် ရေးပါ။"
                              value={editReview?.reviewHeadline}
                              onChange={(e) =>
                                setEditReview({
                                  ...editReview,
                                  reviewHeadline: e.target.value,
                                })
                              }
                            />

                            <InputTextarea
                              className={`p-inputtext-lg ${classes.input_edit_review} ${classes.textarea}`}
                              placeholder="သင့်သုံးသပ်ချက်ကို ဤနေရာတွင် ရေးပါ။"
                              rows={6}
                              cols={30}
                              value={editReview?.reviewDescription}
                              onChange={(e) =>
                                setEditReview({
                                  ...editReview,
                                  reviewDescription: e.target.value,
                                })
                              }
                            />
                          </div>
                          <div className={classes.edit_btns_wrapper}>
                            <button
                              type="button"
                              disabled={editLoading}
                              onClick={() => submitHandler()}
                              className={classes.review_submit_btn}
                            >
                              {editLoading ? (
                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <Spinner theme="light" />
                                </div>
                              ) : (
                                "တင်ပြပါ။"
                              )}
                            </button>
                            <button
                              type="button"
                              // disabled={isLoading}
                              // onClick={() => submitHandler()}
                              className={classes.cancel_edit_review_btn}
                              onClick={() =>
                                setEditReview({
                                  state: false,
                                  editReviewId: null,
                                  reviewDescription: "",
                                  reviewHeadline: "",
                                  reviewStars: 0,
                                })
                              }
                            >
                              မလုပ်တော့
                            </button>
                          </div>
                        </form>
                      ) : (
                        <>
                          <div className={classes.review_rating_container}>
                            <img
                              src="/assets/images/star.png"
                              alt="star"
                              className={classes.review_star}
                            />
                            <div
                              className={classes.review_rating_sub_container}
                            >
                              <p className={classes.review_rating}>
                                {dataItem?.stars_rated}
                              </p>
                              <span className={classes.slash}>/</span>
                              <p className={classes.review_rating_out_of}>10</p>
                            </div>
                          </div>

                          <div className={classes.review_intro_container}>
                            <p className={classes.review_headline}>
                              {JSON.parse(dataItem?.review_headline)}
                            </p>
                            <div className={classes.review_by}>
                              <p className={classes.username}>
                                {dataItem?.username}
                              </p>
                              <p className={classes.review_date}>
                                {new Date(
                                  dataItem?.date_time
                                ).toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "long",
                                  year: "numeric",
                                })}
                              </p>
                            </div>
                          </div>

                          <div className={classes.review_container}>
                            <p
                              className={classes.review}
                              dangerouslySetInnerHTML={{
                                __html: JSON.parse(dataItem?.review).replace(
                                  /\n/g,
                                  "<br />"
                                ),
                              }}
                            ></p>
                          </div>
                          {deleteReview?.state === true &&
                          deleteReview?.reviewId === dataItem?.id ? (
                            <div className={classes.delete_review_btn}>
                              <p className={classes.delete_txt}>
                               ဤသုံးသပ်ချက်ကို ဖျက်လိုသည်မှာ သေချာပါသလား။{" "}
                                {deleteReview?.mediaName}
                              </p>
                              <div className={classes.delete_btns_wrapper}>
                                <button
                                  type="button"
                                  className={classes.no_btn}
                                  onClick={() =>
                                    setDeleteReview({
                                      state: false,
                                      reviewId: null,
                                      mediaName: "",
                                    })
                                  }
                                >
                                  မရှိ
                                </button>

                                <button
                                  type="button"
                                  disabled={deleteLoading}
                                  onClick={() => deleteReviewHandler()}
                                  className={classes.yes_btn}
                                >
                                  {deleteLoading ? (
                                    <div
                                      style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Spinner theme="light" />
                                    </div>
                                  ) : (
                                    "ဟုတ်ကဲ့"
                                  )}
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div className={classes.review_buttons_wrapper}>
                              <button
                                className={classes.edit_review_btn}
                                onClick={() =>
                                  setEditReview({
                                    state: true,
                                    editReviewId: dataItem?.id,
                                    reviewStars: dataItem?.stars_rated,
                                    reviewHeadline: JSON.parse(
                                      dataItem?.review_headline
                                    ),
                                    reviewDescription: JSON.parse(
                                      dataItem?.review
                                    ),
                                  })
                                }
                              >
                                တည်းဖြတ်ပါ။
                              </button>
                              <button
                                className={classes.delete_review_btn}
                                onClick={() =>
                                  setDeleteReview({
                                    state: true,
                                    reviewId: dataItem?.id,
                                    mediaName: dataItem?.media_name,
                                  })
                                }
                              >
                                ဖျက်ပါ။
                              </button>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </React.Fragment>
          )}
          {!isLoading && (
            <div ref={lastItemRef} className={classes.load_item}></div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default UserRatingsModal;
